class SiteFooter extends HTMLElement {
  constructor() {
    super();
    this.backdrop = this.querySelector('.js-footer-backdrop');
    this.init();
  }

  init() {
    if (!this.backdrop) return;

    this.checkVisibility();

    const events = ['scroll', 'resize'];

    events.forEach((event) => {
      window.addEventListener(event, this.checkVisibility.bind(this));
    });
  }

  checkVisibility() {    
    const rect = this.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const footerVisible = rect.top < windowHeight && rect.bottom > 0;

    if (footerVisible) {
      const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
      const totalHeight = rect.height;
      const percentageVisible = Math.max(0, visibleHeight) / totalHeight * 100;

      this.backdrop.style.opacity = `${Math.max(25, percentageVisible)}%`;
    }
  }
}

customElements.define('site-footer', SiteFooter);
